import React from "react";
import ButtonComponent from "@components/ButtonComponent";
import { helperTitle } from "@helpers/helpers";
import {
  ZERO_VALUE,
  TEST_ID_COLUMNS_CONFIG,
  BUTTON_SIZE_SM,
} from "./constants";

/**
 * ConfigurationButton Component
 * Main button to toggle the column configuration popup
 * @param {boolean} openFilter - Whether the popup is open
 * @param {Function} onClick - Callback when button is clicked
 * @param {React.Ref} mainButtonRef - Reference to the button element
 * @param {string} translate - Translation function
 * @param {number} hiddenColumns - Count of hidden columns
 */
const ConfigurationButton = ({
  openFilter,
  onClick,
  mainButtonRef,
  translate,
  hiddenColumns,
}) => {
  return (
    <div>
      <ButtonComponent
        data-testid={TEST_ID_COLUMNS_CONFIG}
        isactive={openFilter}
        color="blue"
        id={TEST_ID_COLUMNS_CONFIG}
        onClick={onClick}
        ref={mainButtonRef}
        noTextSwap={true}
        size={BUTTON_SIZE_SM}
        withoutborder={true}
        text={
          <>
            {helperTitle(translate("shared.columns-configuration"))}
            {hiddenColumns > ZERO_VALUE && (
              <span className="text-primary-400 group-hover:text-white text-xs font-normal">
                {"("}
                {hiddenColumns}
                {")"}
              </span>
            )}
          </>
        }
      />
    </div>
  );
};

export default ConfigurationButton;
